module.exports = __webpack_public_path__ + "media/images/map_icons/Sailing-58eb10db1a60669478b76f8b08ec2f2b.svg";